const AlpsNavigationSDK = require("./SDKLayout").default;

module.exports = AlpsNavigationSDK;
